import dictionaries, { FALLBACK_LANGUAGE } from '../translations';

const resolveByDottedKey = (dictionary, key) => {
    if (!dictionary || typeof dictionary !== 'object') {
        return undefined;
    }

    return key.split('.').reduce((accumulator, segment) => {
        if (accumulator && typeof accumulator === 'object') {
            return accumulator[segment];
        }
        return undefined;
    }, dictionary);
};

/**
 * Looks up a translation key in the requested language with safe fallbacks.
 *
 * Fallback priority:
 *   1. requested language
 *   2. English (FALLBACK_LANGUAGE)
 *   3. the translation key itself (so missing keys are visible during development)
 *
 * @param {string} key - dotted path like "common.save"
 * @param {string} [language] - target language code
 * @returns {string}
 */
const translate = (key, language = FALLBACK_LANGUAGE) => {
    if (typeof key !== 'string' || key.length === 0) {
        return '';
    }

    const primaryValue = resolveByDottedKey(dictionaries[language], key);
    if (typeof primaryValue === 'string') {
        return primaryValue;
    }

    if (language !== FALLBACK_LANGUAGE) {
        const fallbackValue = resolveByDottedKey(dictionaries[FALLBACK_LANGUAGE], key);
        if (typeof fallbackValue === 'string') {
            return fallbackValue;
        }
    }

    return key;
};

export default translate;
